import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";

import { SecondaryStyle } from "../fonts";

import LC from "../assets/Page7LC.webp";
import LA from "../assets/Page7LA.webp";

//@ts-ignore
import LB from "../assets/Page7LB.mp4";

//@ts-ignore
import RB from "../assets/Page7RB.mp4";

import RC from "../assets/Page7RC.webp";

const Page7 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.2vw",
                            md: "1.3vw",
                            lg: "1.35vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      The Wychwood neighborhood offers a blend of urban
                      convenience and natural surroundings. With parks providing
                      green space and tranquility, the area is ideal for
                      enjoying nature within the city. Wychwood Barns serves as
                      a community hub with artist studios, public green spaces,
                      and a lively farmer's market. Nearby, schools like St.
                      Michael’s College School ensure top-tier educational
                      opportunities, and Geary Avenue’s trendy restaurants offer
                      diverse dining options. This neighborhood strikes a
                      balance between peaceful living and the vibrancy of city
                      life, making it a great place for both families and
                      individuals.
                    </Typography>
                  </Grid>

                  {/**LB */}

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: ".5vh solid #fff",
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      backgroundImage: `url('${LA}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: { xs: "45vh", sm: "50vh" },
                    }}
                  />
                </Grid>
              </Grid>

              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "46vh", sm: "50vh" },
                      backgroundImage: `url('${LC}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />

                  {/* LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",

                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: { xs: ".5vh solid #fff", sm: "none" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      height: {
                        xs: "46vh",
                        sm: "100%",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        maxHeight: "50vh",

                        objectFit: "cover",
                      }}
                      src={LB}
                      playsInline
                      autoPlay
                      muted
                      loop
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: "100%",
                    }}
                  >
                    {/* RD */} {/* RA */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: { xs: "1vh solid #fff", sm: "none" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                        },

                        height: { xs: "45vh", sm: "100%" },
                        maxHeight: "50vh",
                      }}
                    >
                      <CardMedia
                        component={"iframe"}
                        allowFullScreen
                        loading="eager"
                        title="Embedded Street View"
                        referrerPolicy="no-referrer-when-downgrade"
                        sx={{
                          border: 0,
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: { xs: "16px", sm: "0vh" },
                        }}
                        src="https://www.google.com/maps/embed?pb=!4v1724396542672!6m8!1m7!1skWC-0wP5UqUi3g9PJ-kzMA!2m2!1d43.67541570749968!2d-79.42365846690117!3f70.01!4f5.329999999999998!5f0.7820865974627469"
                      />
                    </Grid>
                    {/**RC */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fffe",
                        },
                        borderBottom: { xs: ".5vh solid #fff", sm: "none" },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        height: {
                          xs: "46vh",
                          sm: "50vh",
                        },
                        backgroundImage: `url('${RC}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    {/* RC */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },

                        borderBottom: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },

                        height: {
                          xs: "46.5vh",
                          sm: "50vh",
                        },
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: {
                            xs: "45vh",
                            sm: "100%",
                          },
                          maxHeight: "50vh",

                          objectFit: "cover",
                        }}
                        src={RB}
                        playsInline
                        autoPlay
                        muted
                        loop
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page7;
